import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RichTextDocumentComponent } from './rich-text-document/rich-text-document.component';
import { OneSnackBarModule } from '@one/angular-kit/modal';
// import { LearnMoreDialogModule } from '@dia/dialog-reusable-components';
// import { RequestAccessDialogModule } from '@dia/dialog-reusable-components';
// import { FeatureFlagModule } from '@dia/dialog-reusable-components';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CookieService } from 'ngx-cookie-service';
import { RichTextDocumentService } from './rich-text-document/rich-text-document.service';
import { NgxEditorModule } from 'ngx-editor';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [RichTextDocumentComponent],
  exports: [RichTextDocumentComponent],
  imports: [CommonModule, MatCardModule, NgxEditorModule, MatIconModule, MatButtonModule, OneSnackBarModule, ReactiveFormsModule, /*LearnMoreDialogModule, RequestAccessDialogModule, FeatureFlagModule*/],
  providers: [CookieService, RichTextDocumentService]
})
export class RichTextDocumentFeatureModule {}
